import {
  createContext,
  memo,
  useCallback,
  useRef,
  useMemo,
  useContext,
  type FC,
  type PropsWithChildren,
  type MutableRefObject
} from 'react';
import { noop } from '../../../Utilities/utils/noop';

type FuncType = (...args: unknown[]) => void;

interface IActionItemsContext {
  linkedFunc?: MutableRefObject<FuncType>;
  changeLinkedFunc?: (newFunc: FuncType) => void;
}

export const ActionItemsContext = createContext<IActionItemsContext>({});

export const ActionItemsContextProvider: FC<PropsWithChildren> = memo(
  ({ children }) => {
    const linkedFunc = useRef<FuncType>(noop);

    const changeLinkedFunc = useCallback((newFunc: FuncType) => {
      linkedFunc.current = newFunc;
    }, []);

    const value = useMemo(() => {
      return {
        linkedFunc,
        changeLinkedFunc
      };
    }, [changeLinkedFunc, linkedFunc]);

    return (
      <ActionItemsContext.Provider value={value}>
        {children}
      </ActionItemsContext.Provider>
    );
  }
);

export const useActionItemsContext = () => {
  const actionItemsContext = useContext(ActionItemsContext);

  if (!actionItemsContext) {
    throw new Error('wrap the Component in ActionItems Context');
  }

  return actionItemsContext;
};
